/* Medalion Sfințit — comportamentul paginii.
   Galeria, pragurile de cantitate, extraopțiunile și totalul.
   Fără dependințe, fără build. */

(function () {
  'use strict';

  var lei = function (v) {
    return v.toFixed(2).replace('.', ',') + ' Lei';
  };

  /* ---------- galerie ---------- */

  /* Pagina are mai multe carusele. Fiecare stă într-un [data-carousel] și
     își găsește propriile puncte acolo — altfel al doilea ar comanda
     punctele primului. */
  function gallery() {
    [].slice.call(document.querySelectorAll('[data-carousel]')).forEach(function (root) {
      var track = root.querySelector('[data-gal]');
      if (!track) return;
      var dots = [].slice.call(root.querySelectorAll('[data-gal-dot]'));
      var items = [].slice.call(track.querySelectorAll('[data-i]'));
      if (!dots.length || !items.length) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            var i = +e.target.getAttribute('data-i');
            dots.forEach(function (d, k) {
              d.setAttribute('aria-current', k === i ? 'true' : 'false');
            });
          });
        }, { root: track, threshold: 0.6 });
        items.forEach(function (el) { io.observe(el); });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (items[i]) track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- praguri, extra, total ---------- */

  function order() {
    var form = document.querySelector('[data-order]');
    if (!form) return;

    var tiers = [].slice.call(form.querySelectorAll('[data-tier]'));
    var extras = [].slice.call(form.querySelectorAll('[data-extra]'));
    var outSub = form.querySelector('[data-sub]');
    var outTotal = form.querySelector('[data-total]');
    var outExtra = form.querySelector('[data-extra-row]');
    var outExtraVal = form.querySelector('[data-extra-val]');
    if (!outSub || !outTotal) return;

    function recalc() {
      var picked = tiers.filter(function (t) { return t.checked; })[0];
      var sub = picked ? parseFloat(picked.getAttribute('data-price') || '') : NaN;

      var add = 0;
      extras.forEach(function (x) {
        if (x.checked) add += parseFloat(x.getAttribute('data-price') || '0') || 0;
      });

      if (outExtra) outExtra.hidden = add === 0;
      if (outExtraVal && add) outExtraVal.textContent = lei(add);

      /* Un preț nestabilit rămâne vizibil ca nestabilit. Nu inventăm cifre. */
      if (isNaN(sub)) {
        outSub.textContent = 'de stabilit';
        outTotal.textContent = 'de stabilit';
        return;
      }
      outSub.textContent = lei(sub);
      outTotal.textContent = lei(sub + add);
    }

    tiers.concat(extras).forEach(function (el) {
      el.addEventListener('change', recalc);
    });
    recalc();
  }

  /* ---------- butoanele de comandă ---------- */

  /* Toate butoanele paginii trimit spre #comanda. Acolo stă butonul aplicației
     Releasit. În loc să-l ducem pe om până la el, îi dăm noi click: formularul
     se deschide direct, din orice buton.

     Declanșăm click pe butonul real al aplicației, nu pe vreo funcție internă
     de-a ei — un click e singurul lucru pe care Releasit îl garantează. Dacă
     butonul lipsește (aplicația încă se încarcă, sau blocul a fost scos),
     nu facem nimic și rămâne derularea normală spre #comanda. */
  function comanda() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="#comanda"]');
      if (!link) return;

      /* Vizibilitatea se măsoară pe dreptunghi, nu pe offsetParent: butonul
         flotant al aplicației e position:fixed, iar acolo offsetParent e
         mereu null și l-am fi sărit degeaba. */
      var toate = [].slice.call(document.querySelectorAll('.rsi-buy-now-button'));
      var btn = toate.filter(function (b) {
        var r = b.getBoundingClientRect();
        return r.width > 0 && r.height > 0;
      })[0];
      if (!btn) return;

      e.preventDefault();
      btn.click();
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    gallery();
    comanda();
    order();
  });
})();
